// MetricsBar.js
// 8 live KPI cards — recalculate instantly on trade selection changes.
// Last 3 cards: Net Return Potential, Capital Efficiency, Nifty YTD
import React from 'react';

const MetricsBar = ({ stats, niftyData }) => {
    const ytdPct = niftyData?.ytdChangePercent ?? null;
    // Win Rate / Net Return only mean something when closed trades are in scope
    // (e.g. the ACTIVE tab has none) — show "—" rather than a misleading 0%.
    const hasClosed = stats.closed > 0;

    const items = [
        {
            label: 'Selected Reco',
            value: stats.total,
            sub:   'In current view',
            cls:   '',
        },
        {
            label: 'Active Reco',
            value: stats.active,
            sub:   'Open positions',
            cls:   '',
        },
        {
            label: 'Wins',
            value: stats.winners,
            sub:   'Closed positive',
            cls:   'green',
        },
        {
            label: 'Loss',
            value: stats.losers,
            sub:   'Closed negative',
            cls:   'red',
        },
        {
            label: 'Win Rate',
            value: hasClosed ? `${stats.winRate}%` : '—',
            sub:   'Closed trades',
            cls:   !hasClosed ? '' : stats.winRate >= 60 ? 'green' : stats.winRate >= 40 ? 'amber' : 'red',
        },
        {
            label: 'Net Return',
            value: hasClosed ? (stats.portfolioAvg >= 0 ? '+' : '') + stats.portfolioAvg + '%' : '—',
            sub:   'Avg Return (Closed)',
            cls:   !hasClosed ? '' : stats.portfolioAvg >= 0 ? 'green' : 'red',
            gl:    true,
        },
        {
            label: 'Active Return',
            value: stats.unrealisedGain != null
                ? (stats.unrealisedGain >= 0 ? '+' : '') + stats.unrealisedGain + '%'
                : '—',
            sub:   'Avg Return (Active)',
            cls:   stats.unrealisedGain != null
                ? (stats.unrealisedGain >= 0 ? 'green' : 'red')
                : '',
            hl:    true,
        },
        {
            label: 'Total Return',
            value: (stats.totalAvg >= 0 ? '+' : '') + stats.totalAvg + '%',
            sub:   'Avg Return',
            cls:   stats.totalAvg >= 0 ? 'green' : 'red',
            nf:    true,
        },
    ];

    return (
        <div className="metrics-grid">
            {items.map((item, i) => (
                <div
                    className={`metric-card${item.gl ? ' gl' : item.hl ? ' hl' : item.nf ? ' nf' : ''}`}
                    key={i}
                >
                    <div className="metric-card-label">{item.label}</div>
                    <div className={`metric-card-value ${item.cls}`}>{item.value}</div>
                    <div className="metric-card-sub">{item.sub}</div>
                </div>
            ))}
        </div>
    );
};

export default MetricsBar;
